import { jsx as _jsx } from "react/jsx-runtime";
import { CatHeading } from '@blocks-react/components/Heading';
export const DealerLocatorFiltersHeader = ({ children, }) => (_jsx(CatHeading, { variant: "title", children: children }));
